<div class="suspicious-layout" dir="rtl">
  <aside class="suspicious-sidebar">
    <div class="suspicious-brand">
      <div class="suspicious-brandmark" aria-hidden="true">F</div>
      <div>
        <strong>فلیت‌یار</strong>
        <small>مرکز تحلیل تقلب ناوگان</small>
      </div>
    </div>

    <nav class="suspicious-nav" aria-label="پایش رفتار مشکوک">
      <a routerLink="/">
        <i class="fa fa-arrow-right" aria-hidden="true"></i>
        <span>بازگشت به صفحه اصلی</span>
      </a>
      <a routerLink="fraud/overview" routerLinkActive="active">
        <i class="fa fa-th-large" aria-hidden="true"></i>
        <span>نمای کلی</span>
      </a>
      <a routerLink="fraud/cases" routerLinkActive="active">
        <i class="fa fa-folder-open-o" aria-hidden="true"></i>
        <span>پرونده‌های مشکوک</span>
      </a>
      <a routerLink="fraud/case" routerLinkActive="active">
        <i class="fa fa-search" aria-hidden="true"></i>
        <span>جزئیات و شواهد</span>
      </a>
      <a routerLink="fraud/analysis" routerLinkActive="active">
        <i class="fa fa-history" aria-hidden="true"></i>
        <span>وضعیت تحلیل</span>
      </a>
    </nav>

    <div class="suspicious-sidefoot">تشخیص شباهت حرکت دو خودرو</div>
  </aside>

  <main class="suspicious-main">
    <header class="suspicious-header">
      <h1>داشبورد هوشمند تشخیص تقلب</h1>
      <p>بررسی شباهت حرکت، شواهد زمانی و تطبیق مسیر خودروها</p>
    </header>

    <div class="suspicious-content">
      <router-outlet></router-outlet>
    </div>

    <footer class="suspicious-footer">
      فلیت‌یار · داشبورد پایش شباهت حرکت
    </footer>
  </main>
</div>
